export default __webpack_public_path__ + "static/media/defaultIcon.0df7ab79.svg";